import { Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { LocationGroup } from '../../../../types/location-group-response';

type CellParams = ICellRendererParams<LocationGroup> & {
  editCallback: (item: LocationGroup) => void;
  viewCallback: (item: LocationGroup) => void;
};

@Component({
  selector: 'app-pan-cell-locationgroups-list-actions',
  imports: [UiModule, MatTooltipModule, RouterModule, MatMenuModule],
  templateUrl: './cell-locationgroups-list-actions.component.html',
  styleUrl: './cell-locationgroups-list-actions.component.scss',
})
export class CellLocationGroupsListActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
